import injectSheet from 'react-jss'
import Tooltip from './Tooltip'
import styles from './Tooltip.styles'

export default injectSheet(styles)(Tooltip)
